export const WHATSAPP_NUMBER = "919347283220";
export const WHATSAPP_DISPLAY = "+91 93472 83220";

export const EMAIL = "tsrindustryofficial@gmail.com";
export const INSTAGRAM = "https://www.instagram.com/tsr_industry/";
export const LOCATION = "Machilipatnam, Andhra Pradesh, India";
export const MAPS_URL = "https://maps.app.goo.gl/Qt9W4rF1vgQzMfEb7";
export const MAP_EMBED = "https://www.google.com/maps?q=16.1813202,81.1325293&z=17&output=embed";
export const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export const DEFAULT_WA_TEXT =
  "Hello TSR Industry, I'm interested in your CNC machining and custom fabrication services. Please share more details and a quotation.";

export const waLink = (text = DEFAULT_WA_TEXT) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const MAIL_HREF = "mailto:tsrindustryofficial@gmail.com";
export const mailLink = (subject = "Quotation request - TSR Industry", body = "") =>
  `mailto:${EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const requestQuote = (service) => {
  window.dispatchEvent(new CustomEvent("tsr:quote", { detail: service }));
  scrollToId("quote");
};

export const NAV = [
  { id: "services", label: "Services" },
  { id: "woodcraft", label: "Woodcraft" },
  { id: "projects", label: "Projects" },
  { id: "process", label: "Process" },
  { id: "contact", label: "Contact" },
];

export const SERVICE_OPTIONS = [
  "CNC Machining", "CNC Turning & Milling", "Iron Cutting", "Plasma & Laser Cutting",
  "CNC Wood Routing", "Custom Fabrication", "Teak Wood Lotus Flowers", "Pooja Mandir",
  "Wooden Panels", "Furniture", "Other",
];

// Set `photo` to a file in /public/projects/ once genuine photos are supplied.
export const WOODCRAFT = [
  { key: "lotus", title: "Teak Wood Lotus Flowers", text: "Teak wood decorative flowers with brass centres — for pooja mandirs, wooden panels and home décor.", photo: "/projects/lotus.jpg" },
  { key: "mandir", title: "Pooja Mandirs", text: "Custom teak mandirs with intricate CNC designs and traditional detailing, for homes, temples and commercial spaces.", photo: "/projects/mandir.jpg" },
  { key: "panel", title: "Wooden Panels", text: "Decorative wall, partition and door panels cut to your pattern or ours.", photo: "/projects/panel.jpg" },
  { key: "furniture", title: "Furniture", text: "Carved dining tables, beds, sofas, stools and shelving in teak.", photo: "/projects/furniture.jpg" },
];

export const PROJECTS = [
  { src: "/projects/job-doorways.jpg", title: "Teak pooja room, temple doorway & carved main door", tag: "Pooja rooms & doorways", frame: "lg:col-span-12 aspect-[1950/807]" },
  { src: "/projects/job-entrance.jpg", title: "Carved teak entrance with door and window frames", tag: "Entrance frames", frame: "lg:col-span-7 aspect-[4/3] lg:aspect-auto lg:h-[600px]" },
  { src: "/projects/job-flower-hand.jpg", title: "Teak decorative flower with brass centre", tag: "Teak flowers", frame: "lg:col-span-5 aspect-[3/4] lg:aspect-auto lg:h-[600px]" },
  { src: "/projects/job-portfolio.jpg", title: "Furniture & custom fabrication — sofas, dining, beds, TV units, partitions", tag: "Furniture", plain: true, frame: "lg:col-span-8 aspect-[3/2]" },
];
